module.exports = __webpack_public_path__ + "files/0b2c93d7fcc3d412f26a9086c52462b7.png";